import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { PermissionHelper } from '../shared/permissions/permissions';
import { Configuration } from '../shared/services/configuration';
import { HttpClientCustom } from '../shared/services/http.client';
import { ToasterComponent } from '../toasterComponent/toasterComponent';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'underscore';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedData } from 'app/shared/sharedData';

@Component({
    selector: 'delete-mobile-application',
    templateUrl: './deleteMobileApplication.html'
})
export class DeleteMobileComponent{
    public _baseUrl: any;
    constructor(
        public router: Router,
        public _per: PermissionHelper,
        public _global: Configuration,
        public http: HttpClientCustom,
        public translate: TranslateService,
        public _toaster: ToasterComponent, 
        vcr: ViewContainerRef,
        public _location: Location,
        public activeModal: NgbActiveModal,
        public share: SharedData
    ) {
        let self = this;
        self._baseUrl = _global.get('EPMS_BASE_URL');
        self._toaster.setViewRef(vcr);
    }

    public close(booleanValue){
        let self = this;
        self.activeModal.close(booleanValue);
    }

}



// WEBPACK FOOTER //
// ./src/app/superAdmin/deleteMobileApplication.ts